import { CenteredMessage } from './CenteredMessage';

interface LoadingMessageProps {
  message?: string;
}

/**
 * Displays a loading message in a centered container
 */
export function LoadingMessage({ message = 'Loading...' }: LoadingMessageProps) {
  return (
    <CenteredMessage className="loading-container">
      <div>{message}</div>
    </CenteredMessage>
  );
}